import { atom } from 'recoil';

const PREFIX_KEY = 'src/atoms/isEventBarShowing/';

export const isEventBarShowingAtom = atom<boolean>({
  key: `${PREFIX_KEY}isEventBarShowing.atom`,
  default: false,
});
